import React from 'react';
import styled from 'styled-components';

const BackgroundImage = styled.div<{ backgroundImage: string }>`
  width: 100%;
  aspect-ratio: 16/10;
  object-fit: contain;
  z-index: 2;
  background: ${props => props.backgroundImage};
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  transition: all 0.3s ease;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;

  svg {
    max-width: 50%;
    max-height: 100%;
    object-fit: contain;
  }
`;

type CurriculumCoverImageProps = {
  brand: { background: string; logo?: React.ReactElement };
  className?: string;
};

export default function CurriculumCoverImage({ brand, className }: CurriculumCoverImageProps) {
  return (
    <BackgroundImage className={className} backgroundImage={brand?.background}>
      {brand.logo}
    </BackgroundImage>
  );
}
